import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { MetafieldType } from "./return-flow/condition-enums";

const exchangeMetafieldDisplayConfigSchema_ = z.object({
  namespace: z.string().min(1),
  key: z.string().min(1),
  metafieldType: createEnum(MetafieldType),
});

export const exchangeMetafieldDisplayConfigSchema: z.ZodType<ExchangeMetafieldDisplayConfig> =
  exchangeMetafieldDisplayConfigSchema_;
export interface ExchangeMetafieldDisplayConfig extends z.infer<
  typeof exchangeMetafieldDisplayConfigSchema_
> {}

type MetafieldValues = Record<string, unknown> | null | undefined;

export function getExchangeMetafieldBadgeValues(
  configs: readonly ExchangeMetafieldDisplayConfig[],
  productMetafields: MetafieldValues,
  variantMetafields: MetafieldValues,
): string[] {
  return configs.flatMap(({ namespace, key, metafieldType }) => {
    const metafields =
      metafieldType === MetafieldType.PRODUCT
        ? productMetafields
        : variantMetafields;
    const value = metafields?.[`${namespace}.${key}`];

    return typeof value === "string" && value.length > 0 ? [value] : [];
  });
}

export function exchangeMetafieldIdentifiers(
  configs: readonly ExchangeMetafieldDisplayConfig[],
  metafieldType: MetafieldType,
): { namespace: string; key: string }[] {
  return configs
    .filter((config) => config.metafieldType === metafieldType)
    .map(({ namespace, key }) => ({ namespace, key }));
}
